import { DoneIcon, ExpandIcon } from '@change/ds-icons';

import { Chip, ListItem, Modal, ModalBody } from '@change/ds-core-ui/next';

import { useMobileSortSelector } from './hooks/useMobileSortSelector';

type SortSelectorProps = {
	currentRefinement: string;
	currentLabel: string;
	sortByTitle: string;
	options: ReadonlyArray<{ label: string; value: string; subtitle: string }>;
	// FIXME(SelectMenu): Using string | number because the component requires Key type from react-aria as value
	changeSelection: (value: string | number) => void;
};

export const MobileSortSelector: React.FC<SortSelectorProps> = ({
	sortByTitle,
	currentRefinement,
	currentLabel,
	options,
	changeSelection,
}) => {
	const {
		actions: { updateSort },
	} = useMobileSortSelector({ changeSelection });

	return (
		<div className="relative">
			<Modal
				trigger={
					<Chip as="button" trailingIcon={<ExpandIcon />} forceInteractive>
						{sortByTitle} {currentLabel}
					</Chip>
				}
				onClose={() => {}}
			>
				<ModalBody className="space-y-3 pb-10">
					{({ close }) => (
						<>
							{options.map((option) => (
								<ListItem
									onClick={() => {
										updateSort(option.value);
										close();
									}}
									key={option.value}
									label={option.label}
									trailingIcon={currentRefinement === option.value ? <DoneIcon /> : undefined}
									body={option.subtitle}
									className="w-full cursor-pointer text-start focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-stroke-focus-outer"
									data-qa={`sort-option-${option.value}`}
								/>
							))}
						</>
					)}
				</ModalBody>
			</Modal>
		</div>
	);
};
